import { render, staticRenderFns } from "./MyLicensesTable.vue?vue&type=template&id=685284fe&scoped=true&"
import script from "./MyLicensesTable.vue?vue&type=script&lang=ts&"
export * from "./MyLicensesTable.vue?vue&type=script&lang=ts&"
import style0 from "./MyLicensesTable.vue?vue&type=style&index=0&id=685284fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685284fe",
  null
  
)

export default component.exports